import { cn } from '~/shadcn/lib/utils'

type Props = React.HTMLAttributes<HTMLHeadingElement>

function HeadingTwo({ className, ...props }: Props) {
  return (
    <h2
      className={cn(
        'text-[2rem] leading-[1.05] font-semibold tracking-[0.01rem]',
        'md:text-[1.5rem]',
        className
      )}
      {...props}
    />
  )
}

export { HeadingTwo }
